import React, { useEffect, useState } from 'react'

import { Column, Container, Row } from '@/components/base/gridview'
import {
  LezzetDurakgi,
  LezzetDurakgi_MAPPERS,
  LezzetDuraklariProps,
} from './types'
import Video from '@/components/base/video'
import Html from '@/components/base/html'
import Icon from '@/components/base/icon'
import Image from '@/components/base/image'
import Pagination from '@/components/base/pagination'
import { AppContextProps, useApp } from '@wap-client/core'
import { QueryMeta, queryService } from '@wap-client/services'

const LezzetDuraklari: React.FunctionComponent<LezzetDuraklariProps> = ({
  video,
  title,
  description,
}) => {
  const app = useApp()
  const [items, setItems] = useState<Array<LezzetDurakgi>>([])
  const [meta, setmeta] = useState<QueryMeta | null>(null)
  const [searchParams, setsearchParams] = useState({
    city: '',
    title: '',
  })

  useEffect(() => {
    fetcher()
  }, [])

  const fetcher = async (pageIndex: any = 0) => {
    let req = ''
    if (searchParams.city) {
      req = `city=${searchParams.city}`
    }
    if (searchParams.title) {
      req = `title=${searchParams.title}`
    }
    if (pageIndex !== 0) {
      req = `pageIndex=${pageIndex}`
    }

    const response = await queryService.run(
      app.environment,
      {
        name: 'get-app-lezzet-duraklari',
        language: app.language,
        query: req,
      },
      LezzetDurakgi_MAPPERS
    )

    setItems(response.data as Array<LezzetDurakgi>)
    setmeta({ ...response.meta, pageIndex: pageIndex })
  }

  const renderPager = () => {
    if (meta?.totalPage) {
      const pages = []
      for (let index = 1; index < meta?.totalPage + 1; index++) {
        pages.push(
          <span
            onClick={() => {
              fetcher(index - 1)
            }}
            className={`${index === meta.pageIndex + 1 && 'active'}`}
          >
            {index}
          </span>
        )
      }
      if (pages.length > 1) {
        pages.push(
          <span
            onClick={() => {
              meta.totalPage > meta.pageIndex + 1 && fetcher(meta.pageIndex + 1)
            }}
            className="icon"
          >
            <Icon name="chev-right" />
          </span>
        )
      }
      return pages
    }
    return <></>
  }

  return (
    <div className="lezzet-duraklari">
      {!!video && <Video {...video} autoPlay playsInline />}

      <div className="lezzet-duraklari-list">
        <Container size="extended">
          <Row>
            <Column xs={{ size: 12 }}>{title && <h1>{title}</h1>}</Column>
            <Column xs={{ size: 12 }}>
              {description && (
                <Html className="description" content={description} />
              )}
            </Column>
          </Row>
          <Row className="filter">
            <div className="item">
              <input
                type="text"
                onChange={(e) =>
                  setsearchParams({
                    city: e.currentTarget.value,
                    title: '',
                  })
                }
                onKeyUp={(e) => e.key === 'Enter' && fetcher()}
                value={searchParams.city}
                placeholder={app.settings.translations['sehreGoreAra']}
              />
              <Icon name="search-button" onClick={() => fetcher()} />
            </div>
            <div className="item">
              <input
                value={searchParams.title}
                onChange={(e) =>
                  setsearchParams({
                    city: '',
                    title: e.currentTarget.value,
                  })
                }
                onKeyUp={(e) => e.key === 'Enter' && fetcher()}
                type="text"
                placeholder={app.settings.translations['ismeGoreAra']}
              />
              <Icon name="search-button" onClick={() => fetcher()} />
            </div>
          </Row>
          <Row className="pagination">
            <Column xs={{ size: 12 }} md={{ size: 6 }} className="pager">
              {meta && renderPager()}
            </Column>
          </Row>
          <Row className="items">
            {items?.length ? (
              items.map((item) => (
                <Column className="item" lg={{ size: 6 }} xs={{ size: 12 }}>
                  <Image {...item.resim} alt={item.baslik} />
                  <div className="right">
                    <h5>{item.baslik}</h5>
                    {item.adres.href && (
                      <a
                        className="goMap"
                        href={item.adres.href}
                        target="_blank"
                      >
                        Haritaya git <Icon size={'small'} name="pin" />
                      </a>
                    )}
                    {item.sehir && <span>{item.sehir}</span>}
                    {item.kisaAciklama && (
                      <Html
                        className="shortDescription"
                        content={item.kisaAciklama}
                      />
                    )}
                  </div>
                </Column>
              ))
            ) : (
              <p className="noRecordFound">
                {app.settings.translations['noRecordFound']}
              </p>
            )}
          </Row>
        </Container>
      </div>
    </div>
  )
}

export default LezzetDuraklari
